/// <amd-module name="Search/Shared/Base/ActionsHub" />
import * as SearchShared from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";
import { Action } from "VSS/Reflux/Action";
import { IPreviewSetting } from "Search/Shared/Base/Types";
import { SearchSourceType } from "Search/Shared/Base/Sources/SearchSource";
import { IOrganizationInfo } from "Search/Shared/Base/Stores/OrganizationInfoStore";


export interface IItemChangedPayload<TItem> {
    item: TItem;

    activatedOnPreviousNavigation?: boolean;
}

export interface ISearchStartedPayload<TRequest extends SearchShared.EntitySearchQuery> {
    request: TRequest;

    filterApplication?: boolean;

    fetchMoreScenario?: boolean;

    searchTextModified?: boolean;
}

export interface IResultsLoadedPayload<TResponse extends SearchShared.EntitySearchResponse, TItem> {
    response: TResponse;

    activeItem: TItem;

    activityId: string;

    source: SearchSourceType;
}

export interface ISearchFailedPayload<TQuery extends SearchShared.EntitySearchQuery> {
    query: TQuery;

    error: any;

    activityId: string;
}

export interface IFacetsFailedPayload<TQuery> {
    query: TQuery;
}

export interface IPageInitializationStartedPayload<TQuery extends SearchShared.EntitySearchQuery>
    extends ISearchStartedPayload<TQuery> {
    activeTabKey?: string;

    isLandingPage?: boolean;

    launchPoint?: string;
}

export interface IPageInitializedWithSeedDataPayload<TResponse extends SearchShared.EntitySearchResponse> {
    activeTabKey?: string;

    launchPoint?: string;

    response?: TResponse;
}

export interface IPreviewOrientationChangedPayload {
    previewOrientation: IPreviewSetting;
}

export interface ISortOptionChangedPayload<TItem> {
    sortedItems: TItem[];

    sortOption: SearchShared.EntitySortOption;
}

export interface IFacetsLoadedPayload<TResponse extends SearchShared.EntitySearchResponse> {
    response: TResponse;
}

export interface IRepoStatusRefresh {
    lastIndexedTime: Date;
    commitId : string,
    commit: Date;
}

export class ActionsHub<
    TQuery extends SearchShared.EntitySearchQuery,
    TResponse extends SearchShared.EntitySearchResponse,
    TItem
    > {
    public searchStarted = new Action<ISearchStartedPayload<TQuery>>();
    public resultsLoaded = new Action<IResultsLoadedPayload<TResponse, TItem>>();
    public facetsLoaded = new Action<IFacetsLoadedPayload<TResponse>>();
    public facetsUpdated = new Action<IFacetsLoadedPayload<TResponse>>();
    public itemChanged = new Action<IItemChangedPayload<TItem>>();
    public sortOptionChanged = new Action<ISortOptionChangedPayload<TItem>>();
    public searchFailed = new Action<ISearchFailedPayload<TQuery>>();
    public fetchfacetsFailed = new Action<IFacetsFailedPayload<TQuery>>();
    public pageInitializationStarted = new Action<IPageInitializationStartedPayload<TQuery>>();
    public pageInitializedWithSeedData = new Action<IPageInitializedWithSeedDataPayload<TResponse>>();
    public filterPaneToggled = new Action<void>();
    public previewOrientationChanged = new Action<IPreviewOrientationChangedPayload>();
    public filterReset = new Action<void>();
    public organizationInfoLoaded = new Action<IOrganizationInfo>();
    public organizationInfoLoadFailed = new Action<{}>();
    public errorNotificationBannerDismissed = new Action<{}>();
    public splitterFixedSizeChanged = new Action<number>();
    public DataRefreshInfoLoaded = new Action<IRepoStatusRefresh>();
    public StaleBranchBannerLoaded = new Action<void>();
}
